module.exports = __webpack_public_path__ + "img/pickFour_w.0377eadf.png";